import { Tooltip as TooltipPrimitive } from 'radix-ui';
import type { ReactNode } from 'react';

import { cn } from '../cn';
import { Kbd } from './kbd';
import { physicalSide, type LogicalSide } from './side';

export const TooltipProvider = TooltipPrimitive.Provider;

export interface TooltipProps {
  content: ReactNode;
  shortcut?: string;
  children: ReactNode;
  side?: LogicalSide;
  align?: 'start' | 'center' | 'end';
  /** Render nothing extra when there is no content. */
  disabled?: boolean;
}

/** Dark ink tooltip, 12px text. Never the only place information lives. */
export function Tooltip({ content, shortcut, children, side = 'bottom', align = 'center', disabled }: TooltipProps) {
  if (disabled || content == null || content === '') return <>{children}</>;
  return (
    <TooltipPrimitive.Root delayDuration={350}>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={physicalSide(side)}
          align={align}
          sideOffset={6}
          collisionPadding={8}
          className={cn(
            'z-(--z-popover) flex max-w-80 items-center gap-2 rounded-sm bg-primary px-2 py-1 text-meta text-primary-foreground shadow-overlay',
            'data-[state=delayed-open]:animate-fade-in',
          )}
        >
          <span>{content}</span>
          {shortcut ? <Kbd tone="inverse">{shortcut}</Kbd> : null}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
